var heroBanner = require('./experience/heroBanner');
var processInclude = require('base/util');

$(document).ready(function() {
    processInclude(heroBanner);
});
